import { render, staticRenderFns } from "./GroupAnalyticsPrice.vue?vue&type=template&id=a3c3506a&scoped=true"
import script from "./GroupAnalyticsPrice.vue?vue&type=script&lang=js"
export * from "./GroupAnalyticsPrice.vue?vue&type=script&lang=js"
import style0 from "./GroupAnalyticsPrice.vue?vue&type=style&index=0&id=a3c3506a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c3506a",
  null
  
)

export default component.exports